import { VStack } from "../../components/utils";
import { Grant } from "../../types/Grant";
import {
  AllocationMode,
  RuleScope,
} from "../../store/useAllocationMatrixStore";
import { formatCurrency, getCurrencyType } from "../../utils/currencyFormatter";

interface BulkGrantUtilizationCellProps {
  grant: Grant;
  allocatedValue: number;
  priorGrantCount: number;
  currentSharePrice?: number;
}

export function BulkGrantUtilizationCell({
  grant,
  allocatedValue,
  priorGrantCount,
  currentSharePrice,
}: BulkGrantUtilizationCellProps) {
  const currencyType = getCurrencyType();
  const rule = grant.matchedRule as any;

  const isValueMode = rule?.allocationMode === AllocationMode.ABSOLUTE_VALUE;
  const isPerEmployee = rule?.scope === RuleScope.PER_EMPLOYEE;

  const fmtQuantum = (value: number): string => {
    if (isValueMode) return formatCurrency(value, currencyType);
    return `${value.toLocaleString()} Options`;
  };

  if (!grant.allocationMatrixId || !rule || !isPerEmployee) {
    return <span className="text-xs text-gray-light">—</span>;
  }

  if (priorGrantCount === 0) {
    return (
      <VStack className="gap-0.5">
        <div className="text-xs font-semibold text-primaryText">
          {fmtQuantum(0)}
        </div>
        <div className="text-xs text-gray-light">No prior grants</div>
        {isValueMode && currentSharePrice != null && (
          <div className="text-[11px] text-gray-light">
            FMV: {formatCurrency(currentSharePrice, currencyType)}
          </div>
        )}
      </VStack>
    );
  }

  return (
    <VStack className="gap-0.5">
      <div className="text-xs font-semibold text-primaryText">
        {fmtQuantum(allocatedValue)}
      </div>
      <div className="text-xs text-gray-light">
        {priorGrantCount} prior grant
        {priorGrantCount !== 1 ? "s" : ""}
      </div>
      {isValueMode && currentSharePrice != null && (
        <div className="text-[11px] text-gray-light">
          FMV: {formatCurrency(currentSharePrice, currencyType)}
        </div>
      )}
    </VStack>
  );
}
